/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
export interface ICalendarAppBaseText {
    requesting: boolean;
    emptyMonthMessage: string;
    emptyDayMessage: string;
    loadMoreButtonText: string;
    applyPromoCodeButtonText: string;
    setToListViewButtonText: string;
    setToGridViewButtonText: string;
    venueFilterTitleText: string;
    venueAllSelectionText: string;
    categoryFilterTitleText: string;
    categoryAllSelectionText: string;
    productionFilterTitleText: string;
    productionAllSelectionText: string;
    clearAllButtonText: string;
    openFiltersButtonText: string;
    eventSingleString: string;
    eventsPluralString: string;
    fallbackPerformanceThumbnailImage: string;
    promoCodeDescriptionText: string;
    monthDropdownDescriptionText: string;
    apiError: any;
    calendarHeading: string;
    filtersHeading: string;
    controlsHeading: string;
    gridViewHeading: string;
    listViewHeading: string;
    filterTriggerLabel: string;
    filterCloseLabel: string;
    loaderIsLoadingText: string;
    loaderHasLoadedText: string;
    dayOfWeekFilterTitleText: string;
    dateFilterTitleText: string;
    dateAllSelectionText: string;
    accessFilterTitle: string;
    accessAllSelectionText: string;
}

export const defaultBaseText: ICalendarAppBaseText = {
    requesting: false,
    emptyDayMessage: 'There are no events',
    emptyMonthMessage: 'There are no events',
    applyPromoCodeButtonText: 'Apply Code',
    setToListViewButtonText: 'List View',
    loadMoreButtonText: 'Load Next Month',
    apiError: null,
    setToGridViewButtonText: 'Grid View',
    categoryAllSelectionText: 'Series/Genre',
    categoryFilterTitleText: 'Time of day',
    productionAllSelectionText: 'All Productions',
    productionFilterTitleText: 'Performances',
    venueAllSelectionText: 'All Venues',
    venueFilterTitleText: 'Venue',
    dayOfWeekFilterTitleText: 'Day of Week',
    clearAllButtonText: "Reset",
    openFiltersButtonText: "Filters",
    eventSingleString: "event",
    eventsPluralString: "events",
    fallbackPerformanceThumbnailImage: "",
    monthDropdownDescriptionText: "Select month",
    promoCodeDescriptionText: "Enter promo code",
    calendarHeading: "Calendar",
    filtersHeading: "Calendar Filters",
    controlsHeading: "Calendar Controls",
    gridViewHeading: "Calendar Grid",
    listViewHeading: "Calendar List",
    filterTriggerLabel: "Open Filter Dialog",
    filterCloseLabel: "Close Filter Dialog",
    loaderIsLoadingText: "Calendar is loading",
    loaderHasLoadedText: "Calendar has loaded",
    dateFilterTitleText: "Month",
    dateAllSelectionText: "",
    accessFilterTitle: "Accessibility services",
    accessAllSelectionText: ""
}